import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=b986e682&scoped=true&lang=pug&"
import script from "./desktop.vue?vue&type=script&lang=coffee&"
export * from "./desktop.vue?vue&type=script&lang=coffee&"
import style0 from "./header.styl?vue&type=style&index=0&id=b986e682&lang=stylus&scoped=true&"
import style1 from "./desktop.vue?vue&type=style&index=1&id=b986e682&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b986e682",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default,AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
